import React from "react";
import { Title } from "../../components/Title";
import { CardTwo } from "../../components/Card/CardTwo";
import { useTranslation } from "react-i18next";
import "./styles.less";
//
export const DeveloperSdk = () => {
  const { t } = useTranslation();
  const cards = [
    {
      icon:
        "icon authing-icon authing-wechat-miniprogram-app-launch icon-style-miniprogram",
      title: `${t("developer.sdk.item0.title")}`,
      links: [
        {
          text: "查看详情",
          adress: "https://docs.authing.cn/v2/reference/sdk-for-wxapp.html",
        },
      ],
      adress: "https://docs.authing.cn/v2/reference/sdk-for-wxapp.html",
    },
    {
      icon: "icon authing-icon authing-nodejs icon-style",
      title: "JavaScript SDK",
      links: [
        {
          text: "查看详情",
          adress: "https://docs.authing.cn/v2/reference/sdk-for-node/",
        },
      ],
      adress: "https://docs.authing.cn/v2/reference/sdk-for-node/",
    },
    {
      icon: "icon authing-icon authing-javascript icon-style",
      title: "Node.js SDK",
      links: [
        {
          text: "查看详情",
          adress: "https://docs.authing.cn/v2/reference/sdk-for-node/",
        },
      ],
      adress: "https://docs.authing.cn/v2/reference/sdk-for-node/",
    },
    {
      icon: "icon authing-icon authing-bianzu34 icon-style",
      title: "Java SDK",
      links: [
        {
          text: "查看详情",
          adress: "https://docs.authing.cn/v2/reference/sdk-for-java/",
        },
      ],
      adress: "https://docs.authing.cn/v2/reference/sdk-for-java/",
    },
    {
      icon: "icon authing-icon authing-python icon-style",
      title: "Python SDK",
      links: [
        {
          text: "查看详情",
          adress: "https://docs.authing.cn/v2/reference/sdk-for-python/",
        },
      ],
      adress: "https://docs.authing.cn/v2/reference/sdk-for-python/",
    },
    {
      icon: "icon authing-icon authing-php icon-style",
      title: "PHP SDK",
      links: [
        {
          text: "查看详情",
          adress:
            "https://docs.authing.cn/v2/reference/standard-web-application/sdk-for-php/",
        },
      ],
      adress:
        "https://docs.authing.cn/v2/reference/standard-web-application/sdk-for-php/",
    },
    {
      icon: "icon authing-icon authing-bianzu33 icon-style",
      title: "Go SDK",
      links: [
        {
          text: "查看详情",
          adress: "https://docs.authing.cn/v2/reference/sdk-for-go/",
        },
      ],
      adress: "https://docs.authing.cn/v2/reference/sdk-for-go/",
    },
    {
      icon: "icon authing-icon authing-react-native icon-style",
      title: "React Native",
      links: [
        {
          text: "查看详情",
          adress:
            "https://docs.authing.cn/v2/reference/sdk-for-react-native.html",
        },
      ],
      adress: "https://docs.authing.cn/v2/reference/sdk-for-react-native.html",
    },
  ];
  return (
    <div>
      <section className="developer-sdk" id="sdk">
        <div className="inner">
          <Title title={t("developer.sdk.title")}>
            {t("developer.sdk.subtitle")}
          </Title>
          <div className="developer-content">
            {cards.map((item) => {
              return (
                <CardTwo
                  icon={<i className={item.icon}></i>}
                  title={item.title}
                  subtitle={item.subtitle}
                  adress={item.adress}
                />
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};
